{
  "title": "User Management & Roles",
  "subtitle": "Manage organizational hierarchy and secure system access.",
  "addUser": "Add New User",
  "tabs": {
    "users": "Users List",
    "roles": "Roles & Permissions"
  },
  "table": {
    "user": "User Info",
    "role": "Role",
    "department": "Department",
    "accessScope": "Access Scope",
    "status": "Status",
    "lastLogin": "Last Login"
  },
  "status": {
    "active": "Active",
    "inactive": "Inactive",
    "locked": "Locked"
  },
  "form": {
    "username": "Username",
    "email": "Email",
    "password": "Password",
    "firstName": "First Name",
    "lastName": "Last Name",
    "department": "Department",
    "roles": "Roles",
    "client": "Client (required for Client Portal role)",
    "isActive": "Active",
    "accessScope": "Access Scope",
    "branch": "Branch",
    "warehouse": "Warehouse",
    "selectBranchFirst": "Select a branch first.",
    "accessScopes": {
      "Company": "Company",
      "Branch": "Branch",
      "Warehouse": "Warehouse"
    },
    "accessScopeHints": {
      "Company": "Full access to every branch and warehouse in the company.",
      "Branch": "Access limited to one branch, including every warehouse under it.",
      "Warehouse": "Access limited to a single warehouse."
    },
    "validation": {
      "usernameRequired": "Username is required.",
      "emailRequired": "A valid email is required.",
      "passwordMinLength": "Password must be at least 8 characters.",
      "firstNameRequired": "First name is required.",
      "lastNameRequired": "Last name is required.",
      "rolesRequired": "At least one role must be assigned.",
      "branchRequired": "A branch is required for this access scope.",
      "warehouseRequired": "A warehouse is required for this access scope."
    }
  },
  "actions": {
    "lock": "Lock",
    "unlock": "Unlock",
    "resetPassword": "Reset Password"
  },
  "deleteUser": {
    "message": "This user will be permanently removed."
  },
  "permissionsMatrix": "Permissions Matrix",
  "systemRole": "System Role",
  "grnLabelPrintingDisabledHint": "GRN Label Printing is currently disabled in Process Configuration for this company — this permission still governs the Label Designer, but the GRN Label Print screen itself is hidden until re-enabled."
}
